<template>
  <!-- 全局响应遮罩 -->
  <a-spin tip="Loading..." size="large" :spinning="LOADING_STATE">
    <!-- 默认路由出口 -->
    <router-view />
  </a-spin>
  <a-back-top />
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useLoadingStateStore } from "./store/loadingStateStore";
const { LOADING_STATE } = storeToRefs(useLoadingStateStore());
</script>

<style lang="scss">// 全局字体放大设置
html {
  font-size: 16px; // 基础字体从默认的14px增加到16px
}

body {
  font-size: 16px;
}

// 全局按钮字体放大
.ant-btn {
  font-size: 16px !important;
}

// 全局输入框字体放大
.ant-input,
.ant-input-password {
  font-size: 16px !important;
}

// 全局表格字体放大
.ant-table {
  font-size: 16px !important;

  .ant-table-thead > tr > th {
    font-size: 16px !important;
  }

  .ant-table-tbody > tr > td {
    font-size: 16px !important;
  }
}

// 全局标题字体放大
h1 {
  font-size: 32px !important;
}

h2 {
  font-size: 28px !important;
}

h3 {
  font-size: 24px !important;
}

h4 {
  font-size: 20px !important;
}

// 移动端适配
@media screen and (max-width: 768px) {
  html {
    font-size: 15px;
  }

  .ant-btn {
    font-size: 15px !important;
  }

  .ant-table {
    font-size: 15px !important;

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      font-size: 15px !important;
    }
  }
}

@media screen and (max-width: 640px) {
  html {
    font-size: 14px;
  }

  .ant-btn {
    font-size: 14px !important;
  }

  .ant-table {
    font-size: 14px !important;

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      font-size: 14px !important;
    }
  }
}
</style>
